
    document.querySelectorAll('.product-matching-lip-set .pdpv-optval__text').forEach(function(el) {
    // Original text read karein (ya data-original-text attribute se)
    let text = el.getAttribute('data-original-text') || el.innerText;

    if (text.includes('+')) {
      let [part1, part2] = text.split('+').map(s => s.trim());

      // Part 1: "Lipstick" se pehle <br> lagayein
      let formattedPart1 = part1.replace(/Lipstick$/i, '<br>Lipstick');

      // Part 2: "Lip Balm" se pehle <br> lagayein
      let formattedPart2 = part2.replace(/Lip Balm$/i, '<br>Lip Balm');

      // Poora string assemble karein client ki layout ke mutabiq
      el.innerHTML = `${formattedPart1}<br>+<br>${formattedPart2}`;
    }
  });





document.addEventListener("DOMContentLoaded", function () {
  const giftName = document.querySelector(".custom.js-gift-name");

  if (!giftName) return;

  const originalText = giftName.textContent;

  function updateGiftTitle() {
    if (window.innerWidth >= 768) {
      giftName.innerHTML = originalText.replace(" - ", "<br>");
    } else {
      giftName.textContent = originalText;
    }
  }

  updateGiftTitle();
  window.addEventListener("resize", updateGiftTitle);
});



function selectOneTimePurchase() {
    // Page par tamam matching product containers select karein
    const pageContainers = document.querySelectorAll('.product-custom-revised-version, .product-diamond-contour-collagen-custom-pdp-1, .product-diamond-contour-broad-custom-pdp-2, .product-diamond-contour-1-minute-custom-pdp-3, .product-diamond-contour-ultimate-custom-pdp-4, .product-diamond-contour-purifying-custom-pdp-5');
    
    if (pageContainers.length === 0) return;

    // Har product container par alag alag loop chalayein
    pageContainers.forEach(pageContainer => {
        const oneTimeInput = pageContainer.querySelector('input[name="pdpv-purchase"][value="onetime"]');
        const oneTimeLabel = pageContainer.querySelector('label[data-purchase="onetime"]');
        const subLabel = pageContainer.querySelector('label[data-purchase="subscription"]');

        if (oneTimeInput) {
            // Direct click trigger karke theme events activate karein
            if (oneTimeLabel) {
                oneTimeLabel.click();
            } else {
                oneTimeInput.click();
            }

            // Selection aur UI classes update karein
            oneTimeInput.checked = true;

            if (subLabel) subLabel.classList.remove('is-selected');
            if (oneTimeLabel) oneTimeLabel.classList.add('is-selected');

            // Change event dispatch karein taakay price/form state update ho
            oneTimeInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
}

// Page load listener
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', selectOneTimePurchase);
} else {
    selectOneTimePurchase();
}




document.addEventListener('click', function (e) {

  const optionButton = e.target.closest('.pdpv-optval');

  if (!optionButton) return;

  setTimeout(function () {

    // Theme ke updated variant ID ko find karein
    const variantInput = document.querySelector(
      'input[name="id"], select[name="id"]'
    );

    if (!variantInput) return;

    const variantId = variantInput.value;
    const comparePrice = window.variantComparePrices[variantId];

    const comparePriceEl = document.querySelector('[data-compare-price]');

    if (comparePriceEl) {
      comparePriceEl.textContent = comparePrice || '';
    }

  }, 50);

});



document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.pdpv__purchase');

  function syncSubscriptionDetails() {
    const subOption = document.querySelector('.pdpv-opt[data-purchase="subscription"]');
    if (!subOption) return;

    const seeDetailsBtn = subOption.querySelector('.js-see-details');
    const deliverDetails = subOption.querySelector('.pdpv-opt__deliver');

    // Agar subscription par 'is-selected' class HOGI tabhi khulega
    if (subOption.classList.contains('is-selected')) {
      if (seeDetailsBtn) seeDetailsBtn.setAttribute('aria-expanded', 'true');
      if (deliverDetails) deliverDetails.removeAttribute('hidden');
    } else {
      // Agar One-Time select hai ya subscription select NAHI hai toh HIDE kar do
      if (seeDetailsBtn) seeDetailsBtn.setAttribute('aria-expanded', 'false');
      if (deliverDetails) deliverDetails.setAttribute('hidden', '');
    }
  }

  // 1. Initial Page Load par run karein
  syncSubscriptionDetails();

  // 2. Direct Container click handle karein (Kyunki Radio button hidden hai)
  if (container) {
    container.addEventListener('click', function () {
      setTimeout(syncSubscriptionDetails, 50); // Theme JS class update hone ke baad run hoga
    });
  }

  // 3. Class Changes ko live observe karein (In case Shopify theme JS dynamically class badle)
  const observer = new MutationObserver(function () {
    syncSubscriptionDetails();
  });

  document.querySelectorAll('.pdpv-opt').forEach((opt) => {
    observer.observe(opt, { attributes: true, attributeFilter: ['class'] });
  });
});